import "./loader.scss";

const Loader = () => {
  return (
    <div className="loader">
      <div className="loader__container">
        <div class="loader__rotate"></div>
        <div className="loader__text">
          Impero <span className="mainColor">Techne</span>
        </div>
      </div>
    </div>
  );
};

export default Loader;
